export default __webpack_public_path__ + "static/media/BrutalType-Regular.474ad29f.ttf";